<template>
	<client-only>
		<div class="imain2">
			<div class="imain2_air wow fadeInUp"></div>
			<div class="mainbox">
				<div class="ititle wow fadeInUp">
					{{ t('home.zhaodaoyitiaoshihenideluxian') }}
					<p>{{ t('home.zuijindedijiajipiao') }}</p>
				</div>
				<div class="iticket_box wow fadeInUp">
					<div class="iticket_list">
						<div class="swiper-wrapper">
							<div v-for="ticketItem in hotTicketList" :key="ticketItem.id" class="swiper-slide" @click="preSearch(ticketItem)">
								<div class="item">
									<a href="javascript:void(0)" class="item_m">
										<div class="company">
											<img :src="getAssetsCarrierFile(ticketItem.carrier)" />
											{{ ticketItem.carrier }}
										</div>
										<div class="more">{{ t('detail.gengduoxijie') }}</div>
										<div class="con">
											<div class="t">
												<b>{{ ticketItem.fromCityName }}</b>
												<i>{{ ticketItem.fromDate }}</i>
											</div>
											<div class="m">
												<p><span class="tconfont tt-plane"></span></p>
												<i :style="{ visibility: ticketItem.transitTimes !== undefined ? 'unset' : 'hidden' }">{{ t('home.zhongzhuan') }} {{ ticketItem.transitTimes }} {{ t('home.shijian') }}</i>
											</div>
											<div class="t">
												<b>{{ ticketItem.toCityName }}</b>
												<i>{{ ticketItem.retDate }}</i>
											</div>
										</div>
										<div class="foot">
											<div class="tax">{{ t('home.baokuoshuifei') }}</div>
											<div class="price">
												{{ ticketItem.currency }}
												<b>{{ ticketItem.price }}</b>
											</div>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="swiper-btn swiper-prev"><span class="tconfont tt-left"></span></div>
					<div class="swiper-btn swiper-next"><span class="tconfont tt-right"></span></div>
				</div>
			</div>
		</div>
	</client-only>
</template>

<script lang="ts" setup>
import type { HotTicketItem } from '#/home';
import { getHotTicketFun } from '@/store/home';
import { onMounted, ref, watch } from 'vue';
import { getAssetsCarrierFile } from '@/utils/getImgUrl';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const emits = defineEmits(['goSearch']);
let hotTicketList = ref<HotTicketItem[]>(getHotTicketFun());
onMounted(() => {
	setTimeout(() => {
		console.log(hotTicketList.value);
		// @ts-ignore
		new Swiper('.iticket_list', {
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			slidesPerView: 3,
			grid: { fill: 'row', rows: 2 },
			spaceBetween: 0,
			navigation: {
				nextEl: '.iticket_box .swiper-next',
				prevEl: '.iticket_box .swiper-prev',
			},
		});
	}, 220);
});
const preSearch = (ticketItem: HotTicketItem) => {
	emits('goSearch', ticketItem);
};
// 验价时触发的登录
watch(
	() => getHotTicketFun(),
	(oldVal, val) => {
		console.log(oldVal, val);
		console.log(getHotTicketFun());
		hotTicketList.value = getHotTicketFun();
	},
	{
		immediate: true,
		deep: true,
	}
);
</script>

<style lang="scss" scoped>
.iticket_list {
	height: auto;
}
</style>
